import currencySymbol from './currency-symbol'

export default function (value, append = '€', divideBy100 = true) {
  const numericValue = divideBy100 ? (Number(value) / 100) : Number(value)
  let s = numericValue.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  if (append) {
    s += ' ' + currencySymbol(append)
  }
  return s
}
